export const SHIPPING_RULE_MODE = {
  add: 'add',
  edit: 'edit'  
};

export const SHIPPING_TYPE_OPTIONS = [
  { value: 'PER_WEIGHT', label: 'Per KG' }  
];

export const SHIPMENT_MODE_OPTIONS = [
  { value: 'LAND', label: 'Land' },
  { value: 'AIR', label: 'Air' }  
];

export const CURRENCY_OPTIONS = [
  { value: 'INR', label: 'INR' },
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' }
];

export const REGION_CURRENCY_MAP = {
  NA: 'USD',
  EU: 'EUR',
  IN: 'INR'
};

export const COLUMNS = [
  { key: 'shipping_method' },
  { key: 'sac_code' },
  { key: 'base_shipping_cost' },
  { key: 'currency' },
  { key: 'metrics' },
  { key: 'mode_of_delivery' },
  { key: 'status' },  
  { key: 'actions' }
];

export const emptyForm = {  
  shippingRuleName: '',
  sacCode: '',
  shippingCharge: '',
  currency: '',
  shippingType: '',
  shipmentMode: '',
  isActive: true
};


